export default __webpack_public_path__ + "static/media/policy_expired.09d26836.png";